import React from 'react';
import { connect } from 'react-redux';
import withSideEffect from 'react-side-effect';
import { updateBanner } from 'depop/state/overlays';
import { createLink } from 'depop/utils/deeplinks';


class Noop extends React.Component {
  render() {
    return null;
  }
}

function reducePropsToState(propsList) {
  const innermostProps = propsList[propsList.length - 1];

  if (innermostProps) {
    return innermostProps;
  }
  return {};
}

function handleStateChangeOnClient(props) {
  const { update, ...config } = props;

  if (!update) {
    return;
  }

  if (Object.keys(config).length > 0) {
    const { path, referer, canonicalUrl } = config;

    createLink(path, referer, {
      '$canonical_url': canonicalUrl,
      'channel': 'app banner',
    }, (link) => {
      update({
        path,
        referer,
        canonicalUrl,
        link,
      });
    });
  } else {
    update(null);
  }
}

const Wrapped = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(Noop);

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  update: value => dispatch(updateBanner(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Wrapped);



// WEBPACK FOOTER //
// ../src/client/components/deeplinks/Deeplink.js